import { entryCards } from '@/mocks/home';

export default function EntrySection() {
  return (
    <section id="entry" className="w-full bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="max-w-2xl">
          <span className="text-xs md:text-sm font-semibold uppercase tracking-widest text-primary-700">
            Official Entry
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            官方平台入口 · 最新地址 · 下载
          </h2>
          <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-700">
            围绕同一个目标，通常需要确认三类信息。下方分别说明了它们的用途与判断方式，
            建议按「入口 → 地址 → 下载」的顺序逐一核对。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {entryCards.map((card, idx) => (
            <article
              key={card.id}
              className={`flex flex-col rounded-lg border p-5 md:p-6 ${
                idx === 0
                  ? 'border-primary-200 bg-background-50'
                  : 'border-background-200 bg-background-50'
              }`}
            >
              <div className="flex items-center justify-between">
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-secondary-100 text-secondary-800">
                  <i className={`${card.icon} text-xl`}></i>
                </span>
                <span
                  className={`rounded-full px-3 py-1 text-xs font-medium ${
                    idx === 0
                      ? 'bg-primary-100 text-primary-700'
                      : 'bg-accent-100 text-accent-700'
                  }`}
                >
                  {card.tag}
                </span>
              </div>

              <h3 className="mt-5 font-heading text-lg md:text-xl font-bold text-foreground-950">
                {card.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-foreground-700">{card.desc}</p>

              <ul className="mt-5 space-y-2.5 border-t border-background-200 pt-5">
                {card.points.map((point) => (
                  <li key={point} className="flex items-start gap-2 text-sm text-foreground-700">
                    <i className="ri-check-line mt-0.5 text-accent-600"></i>
                    <span>{point}</span>
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </div>

        <div className="mt-8 rounded-lg border border-accent-200 bg-accent-50 p-5 md:p-6">
          <div className="flex items-start gap-3">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-accent-100 text-accent-700">
              <i className="ri-lightbulb-line text-lg"></i>
            </span>
            <div>
              <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950">
                一句话原则
              </h3>
              <p className="mt-1.5 text-sm md:text-base leading-relaxed text-foreground-700">
                凡是与官方公告、官方客户端内提示不一致的入口、地址与下载链接，都应先暂停操作并再次核实。
                官方渠道永远优先于任何第三方页面，包括本页。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}